import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=14688068&scoped=true&"
import script from "./form-wrapper.vue?vue&type=script&lang=js&"
export * from "./form-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./form-wrapper.vue?vue&type=style&index=0&id=14688068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14688068",
  null
  
)

export default component.exports